import { render } from "./CarReservationModule.vue?vue&type=template&id=2bbb23d7&scoped=true"
import script from "./CarReservationModule.vue?vue&type=script&lang=js"
export * from "./CarReservationModule.vue?vue&type=script&lang=js"

import "./CarReservationModule.vue?vue&type=style&index=0&id=2bbb23d7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bbb23d7"]])

export default __exports__